import { Sparkles, HeartHandshake, MapPin } from "lucide-react";
import { useLang } from "../i18n";
import { IMG } from "../data/site";
import Seo, { breadcrumbLd } from "../components/Seo";
import { Reveal, Kicker, MaskLine } from "../components/Reveal";

export default function AboutPage() {
  const { lang, t } = useLang();
  const prefix = lang === "ca" ? "/ca" : "";

  return (
    <div data-testid="about-page" className="pt-32">
      <Seo
        title={t("seo.about.title")}
        desc={t("seo.about.desc")}
        path="/sobre-ecoglow"
        jsonLd={breadcrumbLd([
          { name: "EcoGlow Detailing", path: prefix || "/" },
          { name: t("nav.about"), path: `${prefix}/sobre-ecoglow` },
        ])}
      />
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <Reveal><Kicker>{t("about.kicker")}</Kicker></Reveal>
        <h1 className="mt-4 max-w-3xl font-display text-4xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-5xl lg:text-6xl">
          <MaskLine delay={0.1}>{t("about.title")}</MaskLine>
        </h1>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-12 lg:py-24">
        <div className="grid gap-14 lg:grid-cols-2 lg:items-start">
          <div className="space-y-6">
            <Reveal><p className="text-base leading-relaxed text-zinc-300">{t("about.body1")}</p></Reveal>
            <Reveal delay={0.1}><p className="text-base leading-relaxed text-zinc-300">{t("about.body2")}</p></Reveal>
            <Reveal delay={0.15}><p className="text-base leading-relaxed text-zinc-300">{t("about.body3")}</p></Reveal>
          </div>
          <Reveal delay={0.1}>
            <div className="overflow-hidden rounded-2xl border border-white/5">
              <img src={IMG.side} alt="EcoGlow Detailing" loading="lazy" className="aspect-[4/3] w-full object-cover" />
            </div>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-5 sm:grid-cols-3">
          {[
            { icon: Sparkles, t: t("about.v1t"), d: t("about.v1d") },
            { icon: HeartHandshake, t: t("about.v2t"), d: t("about.v2d") },
            { icon: MapPin, t: t("about.v3t"), d: t("about.v3d") },
          ].map((v, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className="card-sheen h-full rounded-xl border border-white/5 bg-[#121212] p-8 transition-all duration-300 hover:border-[#63E51D]/40">
                <span className="rounded-full bg-[#63E51D]/10 p-3 text-[#63E51D]"><v.icon className="h-6 w-6" /></span>
                <h2 className="mt-5 font-display text-2xl font-bold uppercase tracking-wide text-white">{v.t}</h2>
                <p className="mt-2 text-sm leading-relaxed text-zinc-400">{v.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <div className="pb-10" />
    </div>
  );
}
